var exports = {
  "p": "xb99ab02a--c28afb--list",
};

module.exports = exports;
